
export const LOAD_INTERPRETATION_FILE_DATA_IN_PROGRESS = "LOAD_INTERPRETATION_FILE_DATA_IN_PROGRESS";
export const loadInterpretationFileDataInProgress = () => ({
  type: LOAD_INTERPRETATION_FILE_DATA_IN_PROGRESS,
});

export const LOAD_INTERPRETATION_FILE_DATA_SUCCESS = "LOAD_INTERPRETATION_FILE_DATA_SUCCESS";
export const loadInterpretationFileDataSuccess = (data) => ({
  type: LOAD_INTERPRETATION_FILE_DATA_SUCCESS,
  payload: { data },
});

export const LOAD_INTERPRETATION_FILE_DATA_FAILURE = "LOAD_INTERPRETATION_FILE_DATA_FAILURE";
export const loadInterpretationFileDataFailure = () => ({
  type: LOAD_INTERPRETATION_FILE_DATA_FAILURE,
});

export const OPEN_INTERPRETATION_FILE_DIALOG = "OPEN_INTERPRETATION_FILE_DIALOG";
export const openInterpretationFileDialog = () => ({
  type: OPEN_INTERPRETATION_FILE_DIALOG,
});

export const CLOSE_INTERPRETATION_FILE_DIALOG = "CLOSE_INTERPRETATION_FILE_DIALOG";
export const closeInterpretationFileDialog = () => ({
  type: CLOSE_INTERPRETATION_FILE_DIALOG,
});

export const INTERPRETATION_FILE_OPERATION_COMPLETED = "INTERPRETATION_FILE_OPERATION_COMPLETED";
export const interpretationFileOperationCompleted = () => ({
  type: INTERPRETATION_FILE_OPERATION_COMPLETED,
});